import API from '../utils/api'

const recommenderApiBaseUrl = '/api/recommender';
const contentUrl = recommenderApiBaseUrl + '/getproposals/';


export function recommenderProposals(params) {
  return API.get(contentUrl, {
    params: params
  }).then(response => {
    return response
  })
}